import { useState } from "react";
import useFormatImage from "../../hooks/useFormatImage";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./style.css"

function Gallery({ images }) {
    const [counter, setCounter] = useState(0);

    const prevSlide = () => {
        setCounter(counter === 0 ? images.length - 1 : counter - 1);
    }

    const nextSlide = () => {
        setCounter(counter === images.length - 1 ? 0 : counter + 1);
    }

    const imgURL = useFormatImage({ image: images[counter] ? images[counter] : null });

    return (
        <div className='gallery'>
            <div className="view">
                <i className="img" style={{ backgroundImage: `url('${imgURL}')`}} />

                <button className="btn_switch btn_left" onClick={() => prevSlide()}>
                    <FaChevronLeft />
                </button>

                <button className="btn_switch btn_right" onClick={() => nextSlide()}>
                    <FaChevronRight />
                </button>
            </div>

            <div className="panel_gallery">
                {images.map((img, idx) =>
                    <button key={idx} onClick={() => setCounter(idx)}>
                        <i className="slide" style={{ backgroundImage: `url('${img._url}')`}} />
                    </button>
                )}
            </div>
        </div>
    )
}

export default Gallery;